import React from "react";
import { toast } from "react-toastify";
import {
  type EmailMatch,
  useMatchingRestApi,
} from "../../../hooks/useMatchingRestApi";
import { MatchingPage as MatchingPagePresentation } from "./MatchingPage";

export interface MatchingResults {
  matches: EmailMatch[];
  totalMattersAnalyzed: number;
  candidateInfo: string;
}

export const MatchingPage: React.FC = () => {
  const [candidateInfo, setCandidateInfo] = React.useState("");
  const [matchingResults, setMatchingResults] =
    React.useState<MatchingResults | null>(null);
  const { findMatching, loading, error } = useMatchingRestApi();

  const handleSearch = async (inputCandidateInfo: string) => {
    if (!inputCandidateInfo.trim()) return;

    try {
      const data = await findMatching(inputCandidateInfo);

      if (data) {
        const results = {
          matches: data.matches || [],
          totalMattersAnalyzed: data.totalMattersAnalyzed || 0,
          candidateInfo: inputCandidateInfo,
        };
        setMatchingResults(results);
        setCandidateInfo(inputCandidateInfo);

        // 結果取得成功のトースト表示
        toast.success(`${results.matches.length}件のマッチを発見しました`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
        });
      }
    } catch (_error) {
      // エラー時のトースト表示
      toast.error("マッチング検索に失敗しました", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
      });
    }
  };

  const handleCandidateInfoChange = (info: string) => {
    setCandidateInfo(info);
  };

  return (
    <MatchingPagePresentation
      candidateInfo={candidateInfo}
      matchingResults={matchingResults}
      isLoading={loading}
      onSearch={handleSearch}
      onCandidateInfoChange={handleCandidateInfoChange}
    />
  );
};

export default MatchingPage;
